import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InputComponent } from '../../input/input.component';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-string-input-keypad',
  templateUrl: './string-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class StringInputKeypadComponent extends InputComponent {
  @Output() onBlurOnInput = new EventEmitter();
  @Input()
  valeurParDefaut: string;
  @Input()
  longueurMax = 1000;
  @Input()
  placeholder = '';
  rootForm: UntypedFormGroup;
  libelle$: BehaviorSubject<string>;
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
   /**
   * Lorsque le champ n’est plus sélectionné, on peut le remplir automatiquement si une valeur par défaut est saisie.
   */
  public onBlur(): void {
    if (this.valeurParDefaut && this.rootForm.get(this.label).value === '') {
      this.rootForm.get(this.label).setValue(this.valeurParDefaut);
    }
    this.onBlurOnInput.emit();
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}
